// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__hJtGp","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1sz0r"};